import type { SVGProps } from 'react'

export function PaperPlane(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.60471 11.7275H13.4582M19.0549 13.1416L6.76168 19.6498C5.65999 20.233 5.10884 20.5247 4.74557 20.4408C4.43048 20.3681 4.17012 20.1482 4.04655 19.8494C3.90406 19.5048 4.10104 18.9125 4.49536 17.7296L6.32744 12.2333C6.39001 12.0456 6.42101 11.952 6.43344 11.8559C6.44446 11.7707 6.44501 11.6846 6.43398 11.5994C6.42184 11.5055 6.3912 11.4136 6.33141 11.2343L4.49511 5.72537C4.10079 4.54241 3.90377 3.95071 4.04626 3.60612C4.16983 3.30728 4.43014 3.08694 4.74524 3.01418C5.10856 2.93028 5.65987 3.22178 6.76191 3.80522L19.0551 10.3134C19.9215 10.7721 20.3548 11.0016 20.4964 11.3076C20.6198 11.574 20.6199 11.8812 20.4965 12.1477C20.355 12.4535 19.9218 12.6828 19.0563 13.141L19.0549 13.1416Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
